// extracted by mini-css-extract-plugin
export default {"body":"RTDialog-body-QCEep","wrapper":"RTDialog-wrapper-oFsRP","dialog":"RTDialog-dialog-2Npq1"};